
  Vue.component('qrc-display-panel', {
    props: {
      embedded: { type: Boolean, default: false },
      showPanelOnly: { type: Boolean, default: false },
      seekerName: { type: String, default: 'LearK' },
      seekerId: {},
      qrcUrl: { type: String, default: '/api/v1/qrcode/get-image?qrcv=1' },
      qrcText: {
        type: String,
        default: 'ha scelto LearK, il sistema tecnologicamente più avanzato per la gestione del tuo curriculum'
      }
    },
    data() {
      return {
        show: this.showPanelOnly
      }
    },
    template: '#qrc-display-panel',
    computed: {},
    watch: {},
    methods: {
      addPrintStyle() {
        // Aggiungo uno specifico stile per gestire la stampa QRCode
        const elem = document.querySelector('#qrc-print-style')
        if (!elem) {
          const style = document.createElement('style')
          style.innerHTML = '@page {size: 210mm 297mm; margin : 30mm }'
          style.media = 'print'
          style.id = 'qrc-print-style'

          const ref = document.querySelector('script')
          ref.parentNode.insertBefore(style, ref)
        }
      },
      removePrintStyle() {
        const elem = document.querySelector('#qrc-print-style')
        if (elem) elem.parentNode.removeChild(elem)
      },
      showQrCode() {
        this.addPrintStyle()
        this.title = document.title
        document.title = `QR Code - ${this.seekerName}`
        this.show = true
      },
      hideQrCode() {
        console.log(this.showPanelOnly)
        if (!this.showPanelOnly) {
          this.removePrintStyle()
          document.title = this.title
          this.show = false
        }
      },
      printQrCode() {
        let printIframe = document.querySelector('#qrc-print-iframe')
        if (!printIframe) {
          printIframe = document.createElement('iframe')
          printIframe.id = 'qrc-print-iframe'
          printIframe.src = `/Account/Seeker/EditWidgetPrintQRC${this.seekerId ? `?seekerid=${this.seekerId}` : ''}`

          printIframe.onload = () => {
            setTimeout(() => {
              printIframe.contentWindow.focus()
              printIframe.contentWindow.print()
            }, 500)
          }

          const ref = document.querySelector('#qrc-print')
          ref.appendChild(printIframe)
        } else {
          printIframe.contentWindow.focus()
          printIframe.contentWindow.print()
        }
      },
      shareQrCode() {
        const self = this
        const fileName = `LerakQRC-${self.seekerName.replace(/\s/g, '')}.png`
        let blob
        const config = { url: this.qrcUrl, method: 'get', responseType: 'blob' }

        axios
          .request(config)
          .then(response => {
            blob = response.data
          })
          .catch(error => {
            self.error = true
          })
          .then(() => {
            console.log(blob)
            const file = new File([blob], fileName, { type: blob.type })

            if (navigator.canShare && navigator.canShare({ files: [file] })) {
              navigator
                .share({
                  files: [file],
                  title: `QR Code - ${self.seekerName}`,
                  text: `${self.seekerName} ${self.qrcText}`
                })
                .then(() => console.log('Share was successful.'))
                .catch(error => console.log('Sharing failed', error))
            } else if (navigator.share) {
              navigator
                .share({
                  title: `QR Code - ${self.seekerName}`,
                  text: `${self.seekerName} ${self.qrcText}`,
                  url: 'https://www.leark.it/'
                })
                .then(() => console.log('Successful share'))
                .catch(error => console.log('Error sharing', error))
            }
          })
      }
    },
    mounted() {
      if (this.showPanelOnly) {
        this.showQrCode()
      }
    }
  })
